import { useLocation } from 'react-router-dom'
import './Career.css'
import React, { useEffect,useState } from 'react'
import Banner from '../../assets/images/Career Banner.png'
import Login from '../../assets/images/login.png'
import aos from 'aos';
import 'aos/dist/aos.css'
import axios from 'axios'



const Career = () => {
  const [formData,setFormData]=useState({
    name:'',
    email:'',
    phone:'',
    job_profile:'',
    experience:'',
    message:'',
    pdfFile:null,
    isChecked: false,
  })

  const handleChange = (event) => {
    const {name,value,type,checked}=event.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked :value,
    });
  };

  const handleFileChange = (e) => {
        setFormData({
      ...formData,
      pdfFile: e.target.files[0],
    });
  };


  const handleSubmit = async (event) => {
    event.preventDefault(); 
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('job_profile',formData.job_profile)
    formDataToSend.append('experience',formData.experience)
    formDataToSend.append('message',formData.message)
    formDataToSend.append('pdfFile',formData.pdfFile)

    try {
      const response = await axios.post('http://localhost:4000/api/user', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    axios.post('http://localhost:4000/send-cv', formData)
    alert(response.data.message);

    } catch (error) {
      console.error('Error submitting form:', error);
    }

      setFormData({
        name:'',
        email:'',
        phone:'',
        job_profile:'',
        experience:'',
        message:'',
        file:null,
       isChecked: false,
      })
  
  };


  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0, 0);
  }, [top])


  return (
    <>
      <div className="container-fluid gx-0">
        <img src={Banner} alt="" className="img-fluid" />
      </div>

      <div className="container py-3">
        <div className="row form-container">
          <div className="col-lg-6 col-md-6 img-container">
            <img className='img-fluid' src={Login} alt="" />
          </div>

          <div className="col-lg-6 col-md-6 form-box">
            <form onSubmit={handleSubmit}  data-aos="zoom-in">

              <div className="row mb-3">
              <div className="col-md-6 mb-3">
                <label className="form-label">Name</label>
                <input 
                type="text"
                 className="form-control"
                 id='name'
                 name='name'
                 value={formData.name}
                 onChange={handleChange}
                  placeholder='Enter Your Name' 
                  required />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label">Email</label>
                <input 
                type="email" 
                className="form-control"
                id='email'
                name='email'
                value={formData.email}
                onChange={handleChange} 
                placeholder='Enter Your Email'
                required  />
              </div>
              </div>
          
          <div className="row mb-3">
            <div className="col-md-6 mb-3">
            <label className='form-label'>Phone Number</label>
                <input
                  required
                  type="text"
                  id='phone'
                  name='phone'
                  value={formData.phone}
                  onChange={handleChange}
                  className="form-control"
                  placeholder="Phone Number"
                />
             
            </div>
            <div className="col-md-6 mb-3">
            
                <label className="form-label">Job Profile</label>
                <input 
                required
                type="text"
                id='job_profile'
                name='job_profile'
                value={formData.job_profile}
                onChange={handleChange}
                className='form-control'
                placeholder='Are You Looking For?' />
              
            </div>
            <div className="col-md-12 mb-3">
            
            <label className="form-label">Experience</label>
            <select
             required 
             name="experience" 
             id='experience'
             value={formData.experience}
             onChange={handleChange}
             className="form-select">
               <option value="">Select</option>
              <option value="fresher">Fresher</option>
              <option value="less than a year">Less than a year</option>
              <option value='1 - 2 years'>1 - 2 years</option>
              <option value='2 - 4 years'>2 - 4 years</option>
              <option value='4 - 7 years'>4 - 7 years</option>
              <option value='7 - 10 years'>7 - 10 years</option>
              <option value='10+ years'>10+ years</option>
            </select>
          
        </div>
          </div>

              <label className="d-block mb-4">
                <span className="form-label d-block">Tell us more about yourself</span>
                <textarea
                  required
                  name="message"
                  id='message'
                  value={formData.message}
                  onChange={handleChange}
                  className="form-control"
                  rows="3"
                  placeholder="What motivates you?">
                </textarea>
              </label>

              <label className="d-block mb-4">
                <span className="form-label d-block">Your CV</span>
                <input 
                required 
                type="file"
                accept=".pdf"
                onChange={handleFileChange}
                className="form-control" />
              </label>

                <div className="mb-3">
                <label>
                  <input
                  required
                    type="checkbox"
                    className="form-check-input me-1"
                    id="agreementCheckbox"
                    name="isChecked"
                    checked={formData.isChecked}
                    onChange={handleChange}
                  />
                  I hereby declare that the information provided is true and correct.
                </label>
                </div>
              <div className="mb-3">
                <button type="submit" className="btn btn-danger px-3 rounded-3">Apply</button>
              </div>

            </form>
          </div>

        </div>
      </div>
    </>


  )
}

export default Career
